import { THIRTY_DAYS } from "@walletconnect/time";

export const PROPOSAL_CONTEXT = "proposal";

export const PROPOSAL_EXPIRY = THIRTY_DAYS;

export const PROPOSAL_EXPIRY_MESSAGE = "Proposal expired";
